import React from 'react';
import SpinnerContent from '@shared/spinner/spinner.content';

interface SpinnerProps {
  isActive: boolean;
}

const Spinner: React.FunctionComponent<SpinnerProps> = ({ isActive }) => {
  if (!isActive) {
    return null;
  }
  return <SpinnerContent />;
};

export default Spinner;
